import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IHDCartProceedPaymentResponse } from "@/api_framework/api_modals/Cart";
import { setHDCartProceedPayment } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
export const useProceedPaymentAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (mobile: string, link: string): Promise<IHDCartProceedPaymentResponse | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IHDCartProceedPaymentResponse> = await axios.get(
          `${CART_MODULE?.HD_CART_PROCEED_PAYMENT?.baseURL}?mobile=${mobile}&link=${link}` ?? "",
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          dispatch(setHDCartProceedPayment({ data: res.data.data }));
        } else {
          dispatch(setHDCartProceedPayment({ data: null }));
        }
        return res.data;
      } catch (e: any) {
        if (axios.isAxiosError(e)) {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
        }
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch],
  );

  return execute;
};
